"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatRollout(object) {
    return checkExternalChatRollout(object).fulfilled;
}
exports.isExternalChatRollout = isExternalChatRollout;
function checkExternalChatRollout(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("userId"), __1.hasBoolean("active")).withOptions(options).explain();
}
exports.checkExternalChatRollout = checkExternalChatRollout;
//# sourceMappingURL=ExternalChatRollout.js.map